function getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
}

function closeMainNavigation () {
    const navToggle = document.getElementById('navigation-toggle')
    const navElement = document.getElementById('main_nav')
    const overlay = document.getElementById('overlay')
    const productsMenu = document.getElementById('products-mega-menu')

    navToggle && navToggle.classList.remove('open')
    navElement && navElement.classList.remove('open')
    overlay && overlay.classList.remove('show')
    productsMenu && productsMenu.classList.remove('active')
}

function showMegaMenu (menuElement, overlayElement) {
    menuElement.classList.add('active')
    overlayElement.classList.add('show')
}

function hideMegaMenu (menuElement, overlayElement) {
    menuElement.classList.remove('active')
    overlayElement.classList.remove('show')
    hideActiveSidebar()
    showDefaultSidebar()
}

function toggleMegaMenu (menuElement, overlayElement) {
    menuElement.classList.toggle('active')
    overlayElement.classList.toggle('show')
}

function showDefaultSidebar (showGraphic) {
    const defaultSidebar = document.querySelector('[data-sidebar-default]')
    defaultSidebar.classList.add('active')
    showGraphic === undefined && defaultSidebar.parentElement.classList.add('solutions-menu-sidebar--hide-svg')
}

function hideActiveSidebar () {
    const activeSidebar = document.querySelector('.solutions-menu-sidebar__content.active')
    activeSidebar.classList.remove('active')
    activeSidebar.parentElement.classList.remove('solutions-menu-sidebar--hide-svg')
}

function toggleLinkSidebar (linkElement, position) {
    if (linkElement.getAttribute(`data-${position}-link`)) {
        const linkId = linkElement.getAttribute(`data-${position}-link`)
        const showGraphic = linkElement.dataset.showGraphic
        const sidebarElement = document.querySelector(`[data-${position}-sidebar="${linkId}"]`)

        if (sidebarElement) {
            hideActiveSidebar()
            sidebarElement.classList.add('active')
            showGraphic === undefined && sidebarElement.parentElement.classList.add('solutions-menu-sidebar--hide-svg')
        } else {
            hideActiveSidebar()
            showDefaultSidebar(showGraphic)
        }
    }
}

function toggleMobileMenu (event, trigger) {
    if (event.target.classList.contains('mega-menu__title') || event.target.classList.contains('solutions-menu__content')) {
        trigger.classList.toggle('active')
    }
}

export default function MegaMenuSolutions () {
    const megaMenu = document.querySelector('#solutions-menu')

    if (!megaMenu) {
        return
    }

    const laptopTrigger = document.querySelector('#solutions-laptop-trigger')
    const mobileTrigger = document.querySelector('#solutions-mobile-trigger')
    const overlay = document.querySelector('#megamenu-overlay')
    const topMenuLinks = document.querySelectorAll('[data-top-link]')
    const bottomMenuLinks = document.querySelectorAll('[data-bottom-link]')
    const mobileMenus = document.querySelectorAll('.solutions-menu__content')
    const mobileClose = megaMenu.querySelector('.mega-menu__close')
    const tabletBreakpoint = 1160

    megaMenu.addEventListener('mouseenter', () => {
        getScreenWidth() > tabletBreakpoint && showMegaMenu(megaMenu, overlay)
    })

    megaMenu.addEventListener('mouseleave', () => {
        getScreenWidth() > tabletBreakpoint && hideMegaMenu(megaMenu, overlay)
    })

    if (laptopTrigger) {
        laptopTrigger.addEventListener('mouseenter', () => {
            getScreenWidth() > tabletBreakpoint && showMegaMenu(megaMenu, overlay)
        })

        laptopTrigger.addEventListener('mouseleave', () => {
            getScreenWidth() > tabletBreakpoint && hideMegaMenu(megaMenu, overlay)
        })
    }

    if (mobileTrigger) {
        mobileTrigger.addEventListener('click', () => {
            closeMainNavigation()
            getScreenWidth() <= tabletBreakpoint && toggleMegaMenu(megaMenu, overlay)
        })
    }

    if (mobileClose) {
        mobileClose.addEventListener('click', () => hideMegaMenu(megaMenu, overlay))
    }

    if (overlay) {
        overlay.addEventListener('click', () => hideMegaMenu(megaMenu, overlay))
    }

    if (mobileMenus) {
        mobileMenus.forEach(trigger => trigger.addEventListener('click', event => toggleMobileMenu(event, trigger)))
    }

    if (topMenuLinks.length > 0) {
        topMenuLinks.forEach(link => {
            link.addEventListener('mouseenter', () => toggleLinkSidebar(link, 'top'))
        })
    }

    if (bottomMenuLinks.length > 0) {
        bottomMenuLinks.forEach(link => {
            link.addEventListener('mouseenter', () => toggleLinkSidebar(link, 'bottom'))
        })
    }
}
